@if ((loading$ | async) === false) {
  <div class="grid">
    <div class="col-12">
      <p-card>
        <div class="p-fluid">
          <div class="field">
            <label class="font-medium required-field">Название</label>
            <crm-input-text
              [(value)]="key.name"
              [isError]="$any(errors?.name)"></crm-input-text>
            @if (errors?.name) {
              <small class="p-error">
                {{ errors.name | join }}
              </small>
            }
          </div>

          <div class="field">
            <label class="font-medium required-field">Тип ключа</label>
            <crm-single-select
              [options]="kindOptions"
              [selectedItem]="selectedKindOption"
              (selectedItemChange)="onKindOptionChange($event)"
              [filter]="false"
              appendTo="body"
              optionLabel="name"
              styleClass="w-full"></crm-single-select>
            @if (errors?.kind) {
              <small class="p-error">
                {{ errors.kind | join }}
              </small>
            }
          </div>

          @if (key.kind === kindEnum.ORDINARY) {
            <div class="field">
              <label class="font-medium required-field">Реквизит</label>
              <crm-document-file-template-key-target-single-select
                [target]="key.target"
                [(selectedTarget)]="target"
                (selectedTargetChange)="changeTarget($event)"></crm-document-file-template-key-target-single-select>
              @if (errors?.target) {
                <small class="p-error">
                  {{ errors.target | join }}
                </small>
              }
            </div>
          }

          @if (key.kind === kindEnum.AMOUNT_IN_WORDS) {
            <div class="field">
              <label class="font-medium required-field">Ключ</label>
              <crm-single-select
                [options]="sourceKeyOptions"
                [selectedItem]="selectedSourceKey"
                (selectedItemChange)="onSourceKeyChange($event)"
                [filter]="true"
                appendTo="body"
                optionLabel="name"
                filterBy="name"
                [itemDescriptionField]="'path'"
                styleClass="w-full"></crm-single-select>
              @if (errors?.sourceKey) {
                <small class="p-error">
                  {{ errors.sourceKey | join }}
                </small>
              }
            </div>
          }
        </div>
      </p-card>
    </div>
  </div>

  @if ((form$ | async)?.canWrite) {
    <div class="mt-3">
      <div class="flex flex-wrap justify-content-between">
        <crm-button
          [label]="saveButtonLabel"
          styleClass="p-button-success"
          (onClick)="saveKey()"></crm-button>
        <div class="flex align-items-center gap-2">
          @if ((form$ | async)?.isShowDelete && !key.deleted) {
            <crm-button
              label="Удалить"
              styleClass="p-button-danger p-button-text"
              (onClick)="deleteKey()"></crm-button>
          } @else if ((form$ | async)?.isShowDelete && key.deleted) {
            <crm-button
              icon="pi pi-undo"
              label="Восстановить"
              styleClass="p-button-info p-button-text"
              (onClick)="restoreKey()"></crm-button>
          }
        </div>
      </div>
    </div>
  }
} @else {
  <crm-spinner></crm-spinner>
}
